import {Button, Divider, Form, Row, Space, Typography} from "antd";

import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import "./BillGlass.scss";
import {useAppSelector} from "redux/hooks";
import Right from "./components/Right";
import Left from "./components/Left";
import {PrintColorWhiteSVG} from "assets";
import {ModalCustom} from "components/common";
import GlassPrint from "./GlassPrint/GlassPrint";
const BillGlass = React.forwardRef((props: any, ref) => {
  const [form] = Form.useForm();
  const modalRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      const data = form.getFieldsValue();
      return data;
    },
  }));
  const detailBill = useAppSelector(state => state.glassKiot.detailBill);
  console.log("🚀 ~ file: BillGlass.tsx:21 ~ BillGlass ~ detailBill:", detailBill)
  useEffect(() => {
    if (!detailBill?.glassesSalesDto?.glassesPrescription) {
      form.resetFields();
    } else form.setFieldsValue(detailBill?.glassesSalesDto);
  }, [detailBill]);
  return (
    <div className="bill-glass container">
      <Typography
        style={{
          fontWeight: "bold",
        }}
      >
        Đơn kính
      </Typography>
      <Divider style={{margin: 12}} />
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Right form={form} />
          <Left form={form} />
        </Row>
      </Form>
      <Button
        style={{marginTop: 4}}
        className="btn-sub"
        icon={<PrintColorWhiteSVG />}
        onClick={() => modalRef.current?.openModal()}
      >
        In đơn kính
      </Button>
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={modalRef}
        width={1100}
        centered
      >
        <GlassPrint form={form} />
      </ModalCustom>
    </div>
  );
});

export default BillGlass;
